import CryptoJS from 'crypto-js'
import { saveData } from '../caching/indexdbManager'

export async function addToFilterList(sectionLabel, filterList, taggedFilter) {
  // Check For Section
  let hasSectionFilter = false 
  for(let sectionFilter of filterList) {
    if(sectionFilter.label === sectionLabel) {
     hasSectionFilter = true
    }
  }
  
  if(hasSectionFilter) {
    for(let sectionFilter of filterList) {
      if(sectionFilter.label === sectionLabel) {
        sectionFilter.data.push(taggedFilter)
        sectionFilter.data = sectionFilter.data.sort((a, b) => {
          const labelA = a.label.toLowerCase(); // Convert to lowercase for case-insensitive sorting
          const labelB = b.label.toLowerCase();
  
          if (labelA < labelB) return -1;
          if (labelA > labelB) return 1;
          return 0; // Equal labels
        })
      }
    } 
  }
  else {
    filterList.push({label: sectionLabel, data: [taggedFilter], isAquisition: sectionLabel.includes("(Customer)")? false: true})
  }

  let client_name = JSON.parse(
    CryptoJS.AES.decrypt(
      localStorage.getItem("conceptName"),
      process.env.REACT_APP_PASS
    ).toString(CryptoJS.enc.Utf8)
  )

  await saveData("auienceBuilder", 'abForm', 'favoriteFilters', {
    "selections": filterList,
    "clientName": client_name,
    "ttl": Date.now() + 21600000 // 6 Hours
  })

  return filterList
}


// WEBPACK FOOTER //
// ./src/views/AudienceBuilder/util/taggingFavoriteFilter/addFilterToList.js